import AbstractAnimation from "../abstract-animation";

export abstract class AbstractProductSlide extends AbstractAnimation
{
    getContractedHeight = ($target:JQuery<any>): number => {
        let contractedHeight;
        if (undefined == $target.data('contracted_height') || null == $target.data('contracted_height')) {
            contractedHeight = $target.height();
            $target.data('contracted_height', contractedHeight);
        } else {
            contractedHeight = $target.data('contracted_height');
        }
        return contractedHeight;
    }

    getExpandedHeight = ($target:JQuery<any>): number => {
        let expandedHeight;
        if (undefined == $target.data('expanded_height') || null == $target.data('expanded_height')) {
            expandedHeight = $target.height();
            $target.data('expanded_height', expandedHeight);
        } else {
            expandedHeight = parseInt($target.data('expanded_height'));
        }
        return expandedHeight;
    }
}